import React from 'react';

type FormProps = {
  children: React.ReactNode,
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void,
  submitOnEnter?: boolean,
};

export const Form = ({
  children,
  onSubmit,
  submitOnEnter = true,
}: FormProps) => (
  <form
    onSubmit={(e: React.FormEvent<HTMLFormElement>): void => {
      if (submitOnEnter) {
        e.preventDefault();
      }
      onSubmit && onSubmit(e);
    }}
  >
    {children}
  </form>
);
